// extracted by mini-css-extract-plugin
export default {"appDetailsDocListDivider":"ApplicationDetailsDocList_appDetailsDocListDivider__7evyH","appDetailsDocWrapper":"ApplicationDetailsDocList_appDetailsDocWrapper__GPK-f"};